import {connect} from "react-redux";
import SentRouteMetadata from "../../Components/SentRouteMetadata/SentRouteMetadata";

const mapStateToProps = (store) => {
    return {
        users: store.usersReducer.users
    }
};

const mapDispatchToProps = {};

const SentRouteMetadataContainer = connect(mapStateToProps, mapDispatchToProps)(SentRouteMetadata);

export default SentRouteMetadataContainer;